import ActivityInputBar from '../advisor/ActivityInputBar';

export default ActivityInputBar;
